class CustomSelect {
  constructor(selector) {
    this.selectElement = document.querySelector(`${selector}`);
    this.selectTrigger = this.selectElement.querySelector('.select-trigger');
    this.selectTriggerText = this.selectElement.querySelector('.select-trigger__content');
    this.selectOptionContainer = this.selectElement.querySelector('.select-option-container');
    this.selectOptions = this.selectElement.querySelectorAll('.select-option');
    this.handleOptionBlur = this.handleOptionBlur.bind(this);

    this.selectOptions.forEach((option) => {
      option.addEventListener('click', () => {
        this.selectOption(option);
      });
    });

    document.addEventListener('keydown', this.handleKeyboardNavigation.bind(this));
    document.addEventListener('click', this.handleClickOutside.bind(this));
    this.selectTrigger.addEventListener('click', this.toggleSelectOptions.bind(this));
  }

  openSelectOptions() {
    this.selectOptionContainer.classList.add('select-option-container--open');
    this.selectTrigger.classList.add('select-trigger--open');
  }

  toggleSelectOptions() {
    if (this.selectOptionContainer.classList.contains('select-option-container--open')) {
      this.closeSelectOptions();
    } else {
      this.openSelectOptions();
    }

    // this.selectOptions[0].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    this.selectOptions[0].focus({ focusVisible: true });

    this.selectOptions[0].addEventListener('blur', this.handleOptionBlur.bind(this));

    this.selectTrigger.setAttribute('aria-activedescendant', this.selectOptions[0].id);
  }

  selectOption(selectedOption) {

    console.log(selectedOption);

    this.selectOptions.forEach((option) => {
      option.classList.remove('selected');
      option.setAttribute('aria-selected', 'false');
    });

    const dataValue = selectedOption.dataset.optionValue;
    selectedOption.classList.add('selected');
    selectedOption.setAttribute('aria-selected', 'true');

    const selectOptionContent = selectedOption.querySelector('.select-option__content').innerHTML;

    this.selectTriggerText.textContent = '';
    this.selectTriggerText.insertAdjacentHTML('beforeend', selectOptionContent);

    this.selectTrigger.setAttribute('aria-activedescendant', selectedOption.id);

    this.selectTrigger.dataset.selectedOptionValue = dataValue;

    this.closeSelectOptions();
  }

  handleKeyboardNavigation(event) {
    const selectedOption = this.selectElement.querySelector('.select-option.selected');

    if (event.key === 'Escape') {
      this.closeSelectOptions();
    }

    if (event.key === 'Enter' && this.selectElement.contains(event.target)) {
      this.toggleSelectOptions();

      const selectedOption = this.selectElement.querySelector('.select-option.selected');
      if (selectedOption) {
        this.selectOption(selectedOption);
        event.preventDefault();
      }
    }

    if ((event.key === 'ArrowUp' || event.key === 'ArrowDown') && this.selectOptionContainer.classList.contains('select-option-container--open')) {
      const selectedOption = this.selectElement.querySelector('.select-option.selected');

      const currentIndex = Array.from(this.selectOptions).indexOf(selectedOption);
      let nextIndex;

      if (event.key === 'ArrowUp') {
        nextIndex = currentIndex > 0 ? currentIndex - 1 : this.selectOptions.length - 1;
      } else if (event.key === 'ArrowDown') {
        nextIndex = currentIndex < this.selectOptions.length - 1 ? currentIndex + 1 : 0;
      }

      this.selectOptions.forEach((option) => {
        option.classList.remove('selected');
        option.setAttribute('aria-selected', 'false');
      });

      this.selectOptions[nextIndex].focus({ focusVisible: true });
      this.selectOptions[nextIndex].classList.add('selected');
      this.selectOptions[nextIndex].setAttribute('aria-selected', 'true');

      // this.selectOptions[nextIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest' });

      this.selectOptions[nextIndex].addEventListener('blur', this.handleOptionBlur.bind(this));
    }
  }

  handleClickOutside(event) {
    const isClickedOutside =
      !this.selectTrigger.contains(event.target) &&
      !this.selectOptionContainer.contains(event.target);

    if (isClickedOutside) {
      this.closeSelectOptions();
    }
  }

  handleFocusIn(event) {
    if (document.activeElement === this.selectElement) {
      this.toggleSelectOptions();
    } else if (!this.selectOptionContainer.contains(event.target)) {
      this.closeSelectOptions();
    }
  }

  handleOptionBlur(event) {
    // this.selectTriggerText.textContent = event.target.textContent;
    event.target.removeEventListener('blur', this.handleOptionBlur);
  }

  closeSelectOptions() {
    this.selectOptionContainer.classList.remove('select-option-container--open');
    this.selectTrigger.classList.remove('select-trigger--open');

    this.selectOptions.forEach((option) => {
      option.setAttribute('aria-selected', 'false');
    });

    this.selectTrigger.focus();
  }

  resetOptions() {
    this.selectOptions.forEach((option) => {
      option.classList.remove('selected');
      option.setAttribute('aria-selected', 'false');
    });

    this.selectOptions[0].classList.add('selected');
    this.selectOptions[0].setAttribute('aria-selected', 'true');

    // this.selectOptions[0].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    this.selectOptions[0].focus();

    this.selectOptions[0].addEventListener('blur', this.handleOptionBlur.bind(this));

    this.selectOptions[0].setAttribute('tabindex', '0');
    this.selectOptions.forEach((option) => {
      option.setAttribute('tabindex', '-1');
    });

    this.selectTrigger.setAttribute('aria-activedescendant', this.selectOptions[0].id);
  }
}

window.CustomSelect = CustomSelect;